import React from 'react';

import { PackageConfig } from '../types';

import { PackageCard } from './PackageCard';

interface PackagesDisplayProps {
  packages: PackageConfig[];
  revealedIds: string[];
  shiningId: string | null;
  expandedId: string | null;
  selectedId: string | null;
  tagsVisibleIds: string[];
  onSelect: (id: string) => void;
  compact?: boolean;
}

export const PackagesDisplay: React.FC<PackagesDisplayProps> = ({
  packages,
  revealedIds,
  shiningId,
  expandedId,
  selectedId,
  tagsVisibleIds,
  onSelect,
  compact = false,
}) => {
  return (
    <div className={`ms-packages-section${compact ? ' compact' : ''}`}>
      <span className="ms-packages-title">Recommended Packages</span>
      <div className="ms-packages-grid">
        {packages.map((pkg) => (
          <PackageCard
            key={pkg.id}
            pkg={pkg}
            revealed={revealedIds.includes(pkg.id)}
            shining={shiningId === pkg.id}
            expanded={expandedId === pkg.id}
            selected={selectedId === pkg.id}
            tagsVisible={tagsVisibleIds.includes(pkg.id)}
            onSelect={onSelect}
            compact={compact}
          />
        ))}
      </div>
    </div>
  );
};
